export default __webpack_public_path__ + "static/media/profile_master.001ee73f.png";